import { useNavigate } from "react-router-dom";
import styled from "styled-components";

import GeneralBtn from "../generalBtn";

const FallbackComp = ({ resetErrorBoundary }: any) => {
  const navigate = useNavigate();

  return (
    <FallBackWrapper role="alert">
      <div className="boundary__message__container">
        <h1 className="">Something went wrong!</h1>
        <p className="">
          If this error persist, please try to contact us on X (formerly
          Twitter){" "}
          <a
            href="https://twitter.com/oladottcom"
            // className="text-[#337be8] underline-offset-2 underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            @oladottcom
          </a>
        </p>
        <div className="boundary__btns__con">
          <GeneralBtn
            handleClick={resetErrorBoundary}
            btnContent="Try again"
            btnStyle="boundary__btn"
            btnConStyle=""
          />
          <GeneralBtn
            handleClick={() => {
              navigate("/");
              window.location.reload();
            }}
            btnContent="Go Home"
            btnStyle="boundary__btn"
            btnConStyle=""
          />
        </div>
      </div>
    </FallBackWrapper>
  );
};

export default FallbackComp;

const FallBackWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-inline: 1rem;
  text-align: center;

  .boundary__message__container {
    max-width: 500px;
  }
  .boundary__message__container > h1 {
    font-size: 30px;
    margin-top: 8px;
  }
  .boundary__message__container > p {
    font-size: 18px;
    margin-top: 8px;
  }
  .boundary__message__container > p > a {
    color: var(--dark);
    text-decoration: underline;
    offset: 8px;
  }

  .boundary__btns__con {
    display: flex;
    gap: 12px;
    width: fit-content;
    margin-inline: auto;
  }
  .boundary__btn {
    border-radius: 8px;
  }
`;
